module.exports = __webpack_public_path__ + "static/custom-script-per-plan-5759e52bdb3d2582b88a28c1ac5b362c.png";